module.exports = __webpack_public_path__ + "img/pege-top.1b2d38db.svg";